import { Cloud, Wind, Star, Clock, Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export const WeatherCard = ({ 
  type, 
  data, 
  loading, 
  onFavorite, 
  isFavorite, 
  getFlightCategoryStyle 
}) => {
  const icon = type === "METAR" ? Cloud : Wind;
  const Icon = icon;

  if (loading) {
    return (
      <div className="weather-card p-6 h-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="skeleton w-10 h-10 rounded-lg" />
          <div className="skeleton w-24 h-6 rounded" />
        </div>
        <div className="space-y-3">
          <div className="skeleton w-full h-4 rounded" />
          <div className="skeleton w-3/4 h-4 rounded" />
          <div className="skeleton w-1/2 h-4 rounded" />
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="weather-card p-6 h-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-slate-100 border border-slate-200">
            <Icon className="w-5 h-5 text-slate-400" />
          </div>
          <h3 className="text-lg font-bold text-slate-400">{type}</h3>
        </div>
        <p className="text-slate-400 text-center py-8">
          No {type} data available
        </p>
      </div>
    );
  }

  return (
    <div className="weather-card p-6 h-full card-hover" data-testid={`${type.toLowerCase()}-card`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-blue-100 border border-blue-200">
            <Icon className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-800">{type}</h3>
            <p className="text-xs text-slate-500">{data.icao}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {type === "METAR" && data.flight_category && (
            <Badge 
              className={`${getFlightCategoryStyle(data.flight_category)} border font-bold px-3 py-1`}
              data-testid="flight-category-badge"
            >
              {data.flight_category}
            </Badge>
          )}
          {onFavorite && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onFavorite}
              className={`favorite-btn ${isFavorite ? 'text-yellow-500' : 'text-slate-400 hover:text-yellow-500'}`}
              data-testid="favorite-btn"
            >
              <Star className={`w-5 h-5 ${isFavorite ? 'fill-current' : ''}`} />
            </Button>
          )}
        </div>
      </div>

      <div className="metar-raw" data-testid={`${type.toLowerCase()}-raw`}>
        {data.raw}
      </div>

      {data.fetched_at && (
        <div className="flex items-center gap-2 mt-4 text-xs text-slate-500">
          <Clock className="w-3 h-3" />
          <span>Fetched: {new Date(data.fetched_at).toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit',
            timeZoneName: 'short'
          })}</span>
        </div>
      )}
    </div>
  );
};

export default WeatherCard;
